const rail = {
  rails: "Trilhos", // translated
  senior: "Senior", // translated
  seniors: "Idosos", // translated
  youths: "Jovens", // translated
  yearOld: "anos", // translated
  yearsOld: "anos", // translated
};


export default rail;
